"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.promise");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.removePreference = removePreference;
exports.patchPreference = exports.addPreference = exports.getPreference = exports.getPreferences = void 0;

var _promise = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/promise"));

var _stringify = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/json/stringify"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs3/regenerator"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/asyncToGenerator"));

var _environment = require("../environment");

var _utils = require("../utils");

var _internals = require("../utils/internals");

var userPreferenceURL = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(id) {
    return _regenerator.default.wrap(function _callee$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", (0, _environment.getRoute)('ProfileServices').then(function (base) {
              var _context;

              return (0, _concat.default)(_context = "".concat(base, "/v1/preferences")).call(_context, id ? "/".concat(id) : '');
            }));

          case 1:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee);
  }));

  return function userPreferenceURL(_x) {
    return _ref.apply(this, arguments);
  };
}();

var userPreferenceURLFilter = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
    var application,
        category,
        _args2 = arguments;
    return _regenerator.default.wrap(function _callee2$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            application = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : '';
            category = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : '';
            return _context5.abrupt("return", userPreferenceURL().then(function (base) {
              var _context3, _context4;

              return (0, _concat.default)(_context3 = (0, _concat.default)(_context4 = "".concat(base, "?application=")).call(_context4, application, "&category=")).call(_context3, category);
            }));

          case 3:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee2);
  }));

  return function userPreferenceURLFilter() {
    return _ref2.apply(this, arguments);
  };
}();

var companyPreferenceURL = /*#__PURE__*/function () {
  var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(companyId) {
    return _regenerator.default.wrap(function _callee3$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            return _context7.abrupt("return", (0, _environment.getRoute)('ProfileServices').then(function (base) {
              var _context6;

              return (0, _concat.default)(_context6 = "".concat(base, "/v1/companies/")).call(_context6, companyId, "/preferences");
            }));

          case 1:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee3);
  }));

  return function companyPreferenceURL(_x2) {
    return _ref3.apply(this, arguments);
  };
}();

var companyPreferenceURLFilter = /*#__PURE__*/function () {
  var _ref4 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(companyId) {
    var application,
        category,
        _args4 = arguments;
    return _regenerator.default.wrap(function _callee4$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            application = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : '';
            category = _args4.length > 2 && _args4[2] !== undefined ? _args4[2] : '';
            return _context10.abrupt("return", companyPreferenceURL(companyId).then(function (base) {
              var _context8, _context9;

              return (0, _concat.default)(_context8 = (0, _concat.default)(_context9 = "".concat(base, "?application=")).call(_context9, application, "&category=")).call(_context8, category);
            }));

          case 3:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee4);
  }));

  return function companyPreferenceURLFilter(_x3) {
    return _ref4.apply(this, arguments);
  };
}();

var getPreferences = /*#__PURE__*/function () {
  var _ref5 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5(companyId) {
    return _regenerator.default.wrap(function _callee5$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            return _context11.abrupt("return", (0, _utils.isNullOrEmpty)(companyId) ? userPreferenceURL() : companyPreferenceURL(companyId !== null && companyId !== void 0 ? companyId : ''));

          case 1:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee5);
  }));

  return function getPreferences(_x4) {
    return _ref5.apply(this, arguments);
  };
}();

exports.getPreferences = getPreferences;

var getUserPreference = /*#__PURE__*/function () {
  var _ref6 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee8(application, category) {
    return _regenerator.default.wrap(function _callee8$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            return _context14.abrupt("return", userPreferenceURLFilter(application, category).then( /*#__PURE__*/function () {
              var _ref7 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6(url) {
                return _regenerator.default.wrap(function _callee6$(_context12) {
                  while (1) {
                    switch (_context12.prev = _context12.next) {
                      case 0:
                        return _context12.abrupt("return", fetch(url, {
                          headers: (0, _utils.jsonHeaders)()
                        }));

                      case 1:
                      case "end":
                        return _context12.stop();
                    }
                  }
                }, _callee6);
              }));

              return function (_x7) {
                return _ref7.apply(this, arguments);
              };
            }()).then(_internals.http500Thrower).then( /*#__PURE__*/function () {
              var _ref8 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee7(response) {
                return _regenerator.default.wrap(function _callee7$(_context13) {
                  while (1) {
                    switch (_context13.prev = _context13.next) {
                      case 0:
                        return _context13.abrupt("return", response.json());

                      case 1:
                      case "end":
                        return _context13.stop();
                    }
                  }
                }, _callee7);
              }));

              return function (_x8) {
                return _ref8.apply(this, arguments);
              };
            }()));

          case 1:
          case "end":
            return _context14.stop();
        }
      }
    }, _callee8);
  }));

  return function getUserPreference(_x5, _x6) {
    return _ref6.apply(this, arguments);
  };
}();

var getCompanyPreference = /*#__PURE__*/function () {
  var _ref9 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee11(companyId, application, category) {
    return _regenerator.default.wrap(function _callee11$(_context17) {
      while (1) {
        switch (_context17.prev = _context17.next) {
          case 0:
            return _context17.abrupt("return", companyPreferenceURLFilter(companyId, application, category).then( /*#__PURE__*/function () {
              var _ref10 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee9(url) {
                return _regenerator.default.wrap(function _callee9$(_context15) {
                  while (1) {
                    switch (_context15.prev = _context15.next) {
                      case 0:
                        return _context15.abrupt("return", fetch(url, {
                          headers: (0, _utils.jsonHeaders)()
                        }));

                      case 1:
                      case "end":
                        return _context15.stop();
                    }
                  }
                }, _callee9);
              }));

              return function (_x12) {
                return _ref10.apply(this, arguments);
              };
            }()).then(_internals.http500Thrower).then( /*#__PURE__*/function () {
              var _ref11 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee10(response) {
                return _regenerator.default.wrap(function _callee10$(_context16) {
                  while (1) {
                    switch (_context16.prev = _context16.next) {
                      case 0:
                        return _context16.abrupt("return", response.json());

                      case 1:
                      case "end":
                        return _context16.stop();
                    }
                  }
                }, _callee10);
              }));

              return function (_x13) {
                return _ref11.apply(this, arguments);
              };
            }()));

          case 1:
          case "end":
            return _context17.stop();
        }
      }
    }, _callee11);
  }));

  return function getCompanyPreference(_x9, _x10, _x11) {
    return _ref9.apply(this, arguments);
  };
}();

var createPreference = /*#__PURE__*/function () {
  var _ref12 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee13(companyId, preference) {
    return _regenerator.default.wrap(function _callee13$(_context19) {
      while (1) {
        switch (_context19.prev = _context19.next) {
          case 0:
            return _context19.abrupt("return", companyPreferenceURL(companyId).then( /*#__PURE__*/function () {
              var _ref13 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee12(url) {
                return _regenerator.default.wrap(function _callee12$(_context18) {
                  while (1) {
                    switch (_context18.prev = _context18.next) {
                      case 0:
                        return _context18.abrupt("return", fetch(url, {
                          body: (0, _stringify.default)(preference),
                          headers: (0, _utils.jsonHeaders)(),
                          method: 'POST'
                        }));

                      case 1:
                      case "end":
                        return _context18.stop();
                    }
                  }
                }, _callee12);
              }));

              return function (_x16) {
                return _ref13.apply(this, arguments);
              };
            }()).then(_internals.http500Thrower));

          case 1:
          case "end":
            return _context19.stop();
        }
      }
    }, _callee13);
  }));

  return function createPreference(_x14, _x15) {
    return _ref12.apply(this, arguments);
  };
}();

var updateCompanyPreference = /*#__PURE__*/function () {
  var _ref14 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee15(preference, preferenceId, companyId) {
    return _regenerator.default.wrap(function _callee15$(_context22) {
      while (1) {
        switch (_context22.prev = _context22.next) {
          case 0:
            return _context22.abrupt("return", companyPreferenceURL(companyId).then( /*#__PURE__*/function () {
              var _ref15 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee14(url) {
                var _context20;

                return _regenerator.default.wrap(function _callee14$(_context21) {
                  while (1) {
                    switch (_context21.prev = _context21.next) {
                      case 0:
                        return _context21.abrupt("return", fetch((0, _concat.default)(_context20 = "".concat(url, "/")).call(_context20, preferenceId), {
                          body: (0, _stringify.default)(preference),
                          headers: (0, _utils.jsonHeaders)(),
                          method: 'PUT'
                        }));

                      case 1:
                      case "end":
                        return _context21.stop();
                    }
                  }
                }, _callee14);
              }));

              return function (_x20) {
                return _ref15.apply(this, arguments);
              };
            }()).then(_internals.http500Thrower));

          case 1:
          case "end":
            return _context22.stop();
        }
      }
    }, _callee15);
  }));

  return function updateCompanyPreference(_x17, _x18, _x19) {
    return _ref14.apply(this, arguments);
  };
}();

var addCompanyPreference = /*#__PURE__*/function () {
  var _ref16 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee17(companyId, preference) {
    return _regenerator.default.wrap(function _callee17$(_context24) {
      while (1) {
        switch (_context24.prev = _context24.next) {
          case 0:
            return _context24.abrupt("return", getCompanyPreference(companyId, preference.application, preference.category).then( /*#__PURE__*/function () {
              var _ref17 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee16(response) {
                var preferences, preferenceId;
                return _regenerator.default.wrap(function _callee16$(_context23) {
                  while (1) {
                    switch (_context23.prev = _context23.next) {
                      case 0:
                        preferences = response;

                        if (!((0, _utils.isNullOrEmpty)(preferences) || preferences.length === 0)) {
                          _context23.next = 3;
                          break;
                        }

                        return _context23.abrupt("return", createPreference(companyId, preference));

                      case 3:
                        preferenceId = preferences[0].id;

                        if (preferenceId) {
                          _context23.next = 6;
                          break;
                        }

                        throw new Error('Preference is missing ID');

                      case 6:
                        return _context23.abrupt("return", updateCompanyPreference(preference, preferenceId, companyId));

                      case 7:
                      case "end":
                        return _context23.stop();
                    }
                  }
                }, _callee16);
              }));

              return function (_x23) {
                return _ref17.apply(this, arguments);
              };
            }()));

          case 1:
          case "end":
            return _context24.stop();
        }
      }
    }, _callee17);
  }));

  return function addCompanyPreference(_x21, _x22) {
    return _ref16.apply(this, arguments);
  };
}();

var getPreference = /*#__PURE__*/function () {
  var _ref18 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee18(application, category, companyId) {
    return _regenerator.default.wrap(function _callee18$(_context25) {
      while (1) {
        switch (_context25.prev = _context25.next) {
          case 0:
            return _context25.abrupt("return", (0, _utils.isNullOrEmpty)(companyId) ? getUserPreference(application, category) : getCompanyPreference(companyId !== null && companyId !== void 0 ? companyId : '', application, category));

          case 1:
          case "end":
            return _context25.stop();
        }
      }
    }, _callee18);
  }));

  return function getPreference(_x24, _x25, _x26) {
    return _ref18.apply(this, arguments);
  };
}();

exports.getPreference = getPreference;

function addUserPreference(_x27) {
  return _addUserPreference.apply(this, arguments);
}

function _addUserPreference() {
  _addUserPreference = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee22(preference) {
    return _regenerator.default.wrap(function _callee22$(_context29) {
      while (1) {
        switch (_context29.prev = _context29.next) {
          case 0:
            return _context29.abrupt("return", userPreferenceURL().then( /*#__PURE__*/function () {
              var _ref21 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee21(url) {
                return _regenerator.default.wrap(function _callee21$(_context28) {
                  while (1) {
                    switch (_context28.prev = _context28.next) {
                      case 0:
                        return _context28.abrupt("return", fetch(url, {
                          body: (0, _stringify.default)(preference),
                          headers: (0, _utils.jsonHeaders)(),
                          method: 'POST'
                        }));

                      case 1:
                      case "end":
                        return _context28.stop();
                    }
                  }
                }, _callee21);
              }));

              return function (_x35) {
                return _ref21.apply(this, arguments);
              };
            }()).then(_internals.http500Thrower));

          case 1:
          case "end":
            return _context29.stop();
        }
      }
    }, _callee22);
  }));
  return _addUserPreference.apply(this, arguments);
}

var addPreference = /*#__PURE__*/function () {
  var _ref19 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee19(preference, companyId) {
    return _regenerator.default.wrap(function _callee19$(_context26) {
      while (1) {
        switch (_context26.prev = _context26.next) {
          case 0:
            return _context26.abrupt("return", (0, _utils.isNullOrEmpty)(companyId) ? addUserPreference(preference) : addCompanyPreference(companyId !== null && companyId !== void 0 ? companyId : '', preference));

          case 1:
          case "end":
            return _context26.stop();
        }
      }
    }, _callee19);
  }));

  return function addPreference(_x28, _x29) {
    return _ref19.apply(this, arguments);
  };
}();

exports.addPreference = addPreference;

function updateUserPreference(_x30, _x31) {
  return _updateUserPreference.apply(this, arguments);
}

function _updateUserPreference() {
  _updateUserPreference = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee24(prefId, value) {
    return _regenerator.default.wrap(function _callee24$(_context31) {
      while (1) {
        switch (_context31.prev = _context31.next) {
          case 0:
            return _context31.abrupt("return", userPreferenceURL(prefId).then( /*#__PURE__*/function () {
              var _ref22 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee23(url) {
                return _regenerator.default.wrap(function _callee23$(_context30) {
                  while (1) {
                    switch (_context30.prev = _context30.next) {
                      case 0:
                        return _context30.abrupt("return", fetch(url, {
                          body: (0, _stringify.default)({
                            value: value
                          }),
                          headers: (0, _utils.jsonHeaders)(),
                          method: 'PATCH'
                        }));

                      case 1:
                      case "end":
                        return _context30.stop();
                    }
                  }
                }, _callee23);
              }));

              return function (_x36) {
                return _ref22.apply(this, arguments);
              };
            }()).then(_internals.http500Thrower));

          case 1:
          case "end":
            return _context31.stop();
        }
      }
    }, _callee24);
  }));
  return _updateUserPreference.apply(this, arguments);
}

var patchPreference = /*#__PURE__*/function () {
  var _ref20 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee20(value, prefId, companyId) {
    return _regenerator.default.wrap(function _callee20$(_context27) {
      while (1) {
        switch (_context27.prev = _context27.next) {
          case 0:
            return _context27.abrupt("return", (0, _utils.isNullOrEmpty)(companyId) ? updateUserPreference(prefId, value) : _promise.default.reject(new Error('NOT IMPLEMENTED')));

          case 1:
          case "end":
            return _context27.stop();
        }
      }
    }, _callee20);
  }));

  return function patchPreference(_x32, _x33, _x34) {
    return _ref20.apply(this, arguments);
  };
}();

exports.patchPreference = patchPreference;

function removePreference() {
  throw new Error('Not implemented');
}
